document.addEventListener('DOMContentLoaded', () => {

    const el = document.querySelector('.c-popup');
    if(!el) return;

    el.querySelector('.c-popup__close').addEventListener('click', ()=> {
        document.body.classList.remove('show-popup');
        localStorage.setItem('popup', new Date().toISOString());
    });

    const lastPopupDate = localStorage.getItem('popup');

    if(!lastPopupDate || hasOneDayPassed(lastPopupDate)) {
        document.body.classList.add('show-popup');
    }


    function hasOneDayPassed(dateString) {
        const lastDate = new Date(dateString);
        const currentDate = new Date();


        const timeDifference = currentDate - lastDate;

        // Sprawdź czy różnica jest większa niż 24 godziny (w milisekundach)
        // 24 godz * 60 min * 60 sek * 1000 ms = 86400000 ms
        return timeDifference > (24 * 60 * 60 * 1000);
        // return timeDifference > ( 60 * 1000);
    }

});
